<template>
  <b-card v-if="showPic" id="client" class="image-card shadow m-2">
    <b-row>
      <b-overlay no-center>
        <!--        <template #overlay>-->
        <!--          <PhotoModal v-on:newPic="refreshPhoto" :client="true" :trainer="false"/>-->
        <!--        </template>-->
        <b-avatar
          badge
          badge-top
          badge-offset="-15px"
          badge-variant="dark"
          size="14rem"
          v-bind:src="picPath"
        >
          <template #badge>
            <PhotoModal
              v-bind:client-id="clientId"
              v-on:newPic="refreshPhoto"
              :client="true"
              :trainer="false"
            />
          </template>
        </b-avatar>
      </b-overlay>
      <div class="justify-content-center">
        <hr class="w-100" />
      </div>
    </b-row>
    <b-row>
      <b-col>
        <p style="font-weight: bold">
          <b-icon class="me-2" icon="clock"></b-icon>{{ clubDays }}
          <br />
          <small>Час в клубі</small>
        </p>
      </b-col>
      <!--      <div class="vr"></div>-->
      <b-col>
        <p style="font-weight: bold">
          <b-icon class="me-2" icon="credit-card"></b-icon
          >{{ purchase_sum ? purchase_sum : 0 }} грн
          <br />
          <small>Сума покупок</small>
        </p>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import PhotoModal from "@/components/modals/PhotoModal";
import { mapState } from "vuex";
export default {
  props: {
    photopath: String,
    clubDays: String,
    purchase_sum: Number,
    clientId: Number,
  },
  components: {
    PhotoModal,
  },
  data: function () {
    return {
      file: null,
      showPic: true,
    };
  },
  name: "ClientPhotoCard",
  computed: {
    ...mapState(["current_client"]),
    picPath: function () {
      if (!this.photopath) {
        return require("@/assets/img/anonymous-user.jpg");
      } else {
        return `${process.env.VUE_APP_API}/clients/photo/${this.clientId}`;
      }
    },
  },
  methods: {
    refreshPhoto() {
      this.$emit("refresh");
      setTimeout(() => {
        window.location.reload();
      }, 3500);
    },
  },
};
</script>

<style scoped>
.image {
  max-height: 170px;
  max-width: 200px;
}
</style>
